import React from "react";
import SlokSearch from "./SlokSearch";
import "./styles.css"; // Import custom CSS

function App() {
  return (
    <div className="min-h-screen flex items-center justify-center main-div">
      <h6 className="text-center top-heading">॥ શ્રી સ્વામિનારાયણો વિજયતે ॥</h6>
      <h1 className="text-center heading">॥ સત્સંગદીક્ષા ॥</h1>
      <SlokSearch />
    </div>
  );
}

export default App;
